export const stylePrefix = 'fep'
